export default __webpack_public_path__ + "static/media/safe.472a4aa9.svg";